import axios from 'axios'
import config from '../config/env'

let currentAuthToken = ''

const setToken = token => {
  currentAuthToken = token
}

const getApiClient = (customHeaders = {}, timeout = 120 * 1000) => {
  let headers = {
    Accept: 'application/json',
    Authorization: '',
    ...customHeaders,
  }

  if (currentAuthToken !== '') {
    headers['Authorization'] = `Bearer ${currentAuthToken}`
  }

  return axios.create({
    baseURL: config.API_URL,
    headers,
    timeout,
  })
}

export { getApiClient, setToken }
